<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-10",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 51,
      nextPage: '/questionnaire/section3/11',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'What is the average weekly exercise frequency in the past month?',
        btn: [
          [
            {
              text: '1 or none',
              operation: 'flag1-4_None_add reminder 21'
            }
          ],[
            {
              text: '2-3',
            }
          ],[
            {
              text: '4 or more',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
